module.exports = __webpack_public_path__ + "static/media/Sameer.617ff570.png";